module.exports = __webpack_public_path__ + "img/mind_background_9_th.44c5e336.png";